var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGiftTag = function SvgGiftTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gift-tag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.15.55h4.96c.19 0 .35.16.35.35v4.96c0 .19-.07.36-.2.49l-4.9 4.9c-.27.27-.72.27-.99 0L.75 6.64a.706.706 0 0 1 0-.99l4.9-4.9c.13-.13.31-.2.49-.2h.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86 12c-.33 0-.65-.13-.88-.37L.36 7.02C.12 6.78 0 6.47 0 6.14c0-.33.13-.65.37-.88l4.9-4.9c.24-.24.55-.36.88-.36h4.96c.49 0 .89.4.89.89v4.96c0 .33-.13.65-.36.88l-4.9 4.9c-.24.24-.55.37-.88.37Zm.29-10.91s-.08.02-.11.05l-4.9 4.89c-.06.06-.06.16 0 .22l4.61 4.61c.05.05.17.05.22 0l4.9-4.9s.04-.07.04-.11V1.09H6.15Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84 3.75a.76.76 0 1 0 0-1.52.76.76 0 0 0 0 1.52Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gift-tag_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgGiftTag;